module.exports = __webpack_public_path__ + "static/our_network-f147f2b1a88fd3ea863bbb76836695b5.jpg";